module.exports = __webpack_public_path__ + "static/media/warning.6fe32c08.png";